import React, { Component } from "react";

import "./css/style.css";
import { Header } from "./Header";
import { Projects } from "./Projects";
import { Project } from "./Project";
import { Contact } from "./Contact";
import { About } from "./About";
import { Studio } from "./Studio";
import { Route, Switch, withRouter } from "react-router-dom";
import axios from "axios";
const dir = "//api.moiz.eu/



class App extends Component {
  constructor() {
    super();
    this.state = {
      filtersWidth: "",
      isOverflow: false,
      isMobieDevice: null,
      isMobile: null,
      isMenuOpen: false,
      isHovered: null,
      left: null,
      top: null,
      isLoading: 0,
      isTextareaActive: false,
      mainMenu: [],
      projects: [],
      filteredProjects: [],
      filter: [],
      isFiltered: false,
      filters: [],
      fullName: "",
      email: "",
      message: "",
      messageHeight: "20",
      about: [],
      studio: [],
      isFocused: "",
      isBlur: "",
      submitBtnText: "wyślij",
      fullNameValidated: null,
      emailValidated: null,
      messageValidated: null,
      isStatusInfoVisible: false,
      singleFilerClass: false,
      statusInfo: ""
    };
  }
  componentDidMount() {
   
    this.handleIsMobileDevice();
    this.getProjects();
    this.getMenu();
    this.getAbout();
    this.getStudio();
    this.checkIsMobile();
    window.addEventListener("resize", this.checkIsMobile);
  
  }
  componentWillUnmount(){window.removeEventListener("resize", this.checkIsMobile)}
  checkIsMobile = () => {
    if (window.innerWidth <= 767) {
      this.setState({ isMobile: true });
    } else if (window.innerWidth >= 768) {
      this.setState({
        isMobile: false
      });
    }
  };

  toggleFocused = (event, type) => {
    if (this.state[type] === "") {
      this.setState({
        isFocused: type
      });
    }
  };
  toggleBlurred = (event, type) => {
    const validated = event.target.name + "Validated";
    this.setState({
      isFocused: ""
    });

    if (!event.target.checkValidity()) {
     
      this.setState({ [validated]: false });
      return;
    } else {
      this.setState({ [validated]: true });
    }
  };
  toggleOpenMenu = () => {
    const toggleMenu = this.state.isMenuOpen ? false : true;
    this.setState({
      isMenuOpen: toggleMenu
    });
  };
  closeMenu = () => {
    this.setState({
      isMenuOpen: false
    });
  };
  mouseEnter = (e, i) => {
   
    this.setState({ isHovered: i });
  };
  mouseLeave = () => {
    this.setState({ isHovered: null });
  };
  mouseMove = e => {
   
    // let YLimit =
    //   e.target.getBoundingClientRect().height +
    //   e.target.getBoundingClientRect().y;
    this.setState({
      left: e.clientX - e.target.getBoundingClientRect().left + 25,
      top: e.clientY - e.target.getBoundingClientRect().top
    });
  };
  getProjects = () => {
    let projectsData = `${dir}/wp/v2/projects/?per_page=100`;    
    axios
      .get(projectsData)
      .then(res => {
       
       this.uniqeFilterArr = uniq;

        if(res.status === 200) {
          this.filterArr = [];
          this.filters = res.data.map((filter, index) =>
            this.filterArr.push(filter.acf.type)
          );
          
  
          var uniq = this.filterArr.reduce(function(a,b){
            if (a.indexOf(b) < 0 ) a.push(b);
            return a;
          },[]);
          this.setState({
            projects: res.data,
            filteredProjects: res.data,
            filters: this.uniqeFilterArr,
           
          }, ()=> {
           
            this.setState((prevState) => {
              return {isLoading: prevState.isLoading + 1 };
            });



          });
        }
      
      })
      .catch(error => {
        
       console.log(error)
      });
  };
  getAbout = () => {
    let aboutData = `${dir}/wp/v2/about/?embedded`;
    
    axios
      .get(aboutData)
      .then(res => {
        this.filterArr = [];
        this.filters = res.data.map((filter, index) =>
          this.filterArr.push(filter.acf.type)
        );
        this.uniqeFilterArr = [...new Set(this.filterArr)];
        this.setState({
          about: res.data[0].acf
        },  this.setState((prevState) => {
          return {isLoading: prevState.isLoading + 1 };
        }));
      })
      .catch(error => {
       
       console.log(error)
      });
  };
  getStudio = () => {
    let studioData = `${dir}/wp/v2/studio/?embedded`;
    
    axios
      .get(studioData)
      .then(res => {
        this.filterArr = [];
        this.filters = res.data.map((filter, index) =>
          this.filterArr.push(filter.acf.type)
        );
        this.uniqeFilterArr = [...new Set(this.filterArr)];

        this.setState({
          studio: res.data[0].acf,

        },  this.setState((prevState) => {
          return {isLoading: prevState.isLoading + 1 };
        }));
      })
      .catch(error => {
       
       console.log(error)
      });
  };
  getMenu = () => {
    let menuData = `${dir}/wp-api-menus/v2/menus/3/`;

    axios
      .get(menuData)
      .then(res => {


        this.setState({
          mainMenu: res.data.items
        },  this.setState((prevState) => {
          return {isLoading: prevState.isLoading + 1 };
        }));
      })
      .catch(error => {
       
       console.log(error)
      });
  };
  handleFilter = e => {
   

    this.setState({
      filter: e.target.value,
      isFiltered: true,
      filtersWidth: e.target.parentNode.parentNode.parentNode.clientWidth,
      singleFilerClass: true
    });
    let that = this;
    setTimeout(function() {
      if (that.state.filter.length > 0) {
        let newProjects = [];
        that.state.projects
          .filter(project => project.acf.type === that.state.filter)
          .map((project, index) => newProjects.push(project));
        that.updateProjects(newProjects);
      }
    }, 100);
  };
  updateProjects = newVal => {
    this.setState({
      filteredProjects: newVal
    });
  };
  handleCloseBtn = () => {
    this.setState({
      isFiltered: false,
      filteredProjects: this.state.projects,
      singleFilerClass: false
    });
  };

  handleInputChange = event => {
    const target = event.target;
    let name = target.name;
    const value = target.value;

    this.setState({
      [name]: value,
      isStatusInfoVisible: false
    });

    this.setState({
      [name]: value
    });
    if (name === "message") {



      if (this.state.message.length >= 1) {
        this.setState({
          messageHeight: event.target.scrollHeight
        });
      }
      if (this.state.message.length === 0) {
        this.setState({
          messageHeight: 20
         
        });
      }
    }
  };
  handleTextareaClear = () =>{
    const toggle= this.state.isTextareaActive ? false : true;

    if(this.state.message.length === 0) {


      this.setState({isTextareaActive: toggle})
    }
   
  }

  



  checkFormField = type => {
    let validated = type + "Validated";
    let validateEmail = email => {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      
      return re.test(String(email).toLowerCase());
    };

    if (type === "email") {
      this.setState({
        [validated]: validateEmail(this.state.email)
      });
      if (validateEmail(this.state.email) === false) {
        this.setState({
          email: ""
        });
      }
    } else {
      if (this.state[type].length === 0 && this.state[validated] === null) {
        this.setState({
          [validated]: false
        });
      }
      if (this.state[type].length === 0 && this.state[validated] === false) {
        this.setState({
          [validated]: false
        });
      }
      if (this.state[type].length > 0 && this.state[validated] === null) {
        this.setState({
          [validated]: true
        });
      }
      if (this.state[type].length > 0 && this.state[validated] === true) {
      }
      if (this.state[type].length > 0 && this.state[validated] === false) {
        this.setState({
          [validated]: true
        });
      }
    }
  };
  handleSubmit = event => {
    event.preventDefault();

    if (!event.target.checkValidity()) {
      
      this.checkFormField("fullName");
      this.checkFormField("email");
      this.checkFormField("message");

      return;
    } else {
     
      this.setState({ submitBtnText: "wysyłam..." });
      let formData = new FormData();
      formData.append("form_name", this.state.fullName);
      formData.append("form_email", this.state.email);
      formData.append("form_msg", this.state.message);

      axios({
        method: "POST",
        url: "//moiz.eu/mailer.php",
        data: formData
      }).then(response => {
       
        if (response.statusText === "OK") {
          this.setState({
            fullNameValidated: null,
            emailValidated: null,
            messageValidated: null,
            submitBtnText: "wyślij",
            fullName: "",
            email: "",
            message: "",
            isStatusInfoVisible: true,
            statusInfo: "Dziękujemy za wiadomość!"
          });
        } else if (response.statusText === "OK") {
          this.setState({
            fullNameValidated: null,
            emailValidated: null,
            messageValidated: null,
            submitBtnText: "wyślij",
            fullName: "",
            email: "",
            message: "",
            isStatusInfoVisible: true,
            statusInfo: "Coś poszło nie tak, spróbuj ponownie!"
          });
        }
      });
    }
  };

  handleIsMobileDevice = () => {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i.test(
        navigator.userAgent || navigator.vendor || window.opera
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
        (navigator.userAgent || navigator.vendor || window.opera).substr(0, 4)
      )
    ) {
      this.setState({
        isMobileDevice: true
      });
    } else {
      this.setState({
        isMobileDevice: false
      });
    }
  };

  handleOverflow = () => {
    const toggleOverflow = this.state.isOverflow ? false : true;
    this.setState({
      isOverflow: toggleOverflow
    });
  };
  toggleSingleFilerClass = () => {
    const toggleSingleFilerClass = this.state.singleFilerClass ? false : true;
    this.setState({
      singleFilerClass: toggleSingleFilerClass
    });
  };

  render() {

    const { location } = this.state;

    return (
      <div 
      style={{
        position:this.state.isMenuOpen && this.state.isMobile ? 'fixed': null,
        overflow:this.state.isMenuOpen && this.state.isMobile ? 'hidden': null}}
      
      
      className={this.state.isOverflow ? "overflow" : ""}>



        {this.state.isLoading === 4 && (
          <div className={this.state.isMobileDevice ? "mobile" : ""}>
            <Header
              mainMenu={this.state.mainMenu}
              isMobile={this.state.isMobile}
              isMenuOpen={this.state.isMenuOpen}
              toggleOpenMenu={this.toggleOpenMenu}
              closeMenu={this.closeMenu}
            />
            <Switch location={location}>
              {/* <Redirect from="/" exact to="/projekty" /> */}
              <Route
                exact
                path={`/`}
                render={state => (
                  <Projects
                    {...state}
                    isHovered={this.state.isHovered}
                    left={this.state.left}
                    top={this.state.top}
                    mouseMove={this.mouseMove}
                    mouseEnter={this.mouseEnter}
                    mouseLeave={this.mouseLeave}
                    filter={this.state.filter}
                    filters={this.state.filters}
                    isFiltered={this.state.isFiltered}
                    mainMenu={this.state.mainMenu}
                    projects={this.state.projects}
                    filteredProjects={this.state.filteredProjects}
                    updateProjects={this.updateProjects}
                    isLoading={this.state.isLoading}
                    handleCloseBtn={this.handleCloseBtn}
                    handleFilter={this.handleFilter}
                    isMobileDevice={this.state.isMobileDevice}
                    getProjects={this.getProjects}
                    filtersWidth={this.state.filtersWidth}
                    toggleSingleFilerClass={this.toggleSingleFilerClass}
                    singleFilerClass={this.state.singleFilerClass}
                  />
                )}
              />
               <Route
                exact
                path={`/projekty`}
                render={state => (
                  <Projects
                    {...state}
                    isHovered={this.state.isHovered}
                    left={this.state.left}
                    top={this.state.top}
                    mouseMove={this.mouseMove}
                    mouseEnter={this.mouseEnter}
                    mouseLeave={this.mouseLeave}
                    filter={this.state.filter}
                    filters={this.state.filters}
                    isFiltered={this.state.isFiltered}
                    mainMenu={this.state.mainMenu}
                    projects={this.state.projects}
                    filteredProjects={this.state.filteredProjects}
                    updateProjects={this.updateProjects}
                    isLoading={this.state.isLoading}
                    handleCloseBtn={this.handleCloseBtn}
                    handleFilter={this.handleFilter}
                    isMobileDevice={this.state.isMobileDevice}
                    getProjects={this.getProjects}
                    filtersWidth={this.state.filtersWidth}
                    toggleSingleFilerClass={this.toggleSingleFilerClass}
                    singleFilerClass={this.state.singleFilerClass}
                  />
                )}
              />
              <Route
                exact
                path={`/projekty/:slug`}
                render={state => (
                  <Project
                    {...state}
                    filteredProjects={this.state.filteredProjects}
                    mainMenu={this.state.mainMenu}
                    isLoading={this.state.isLoading}
                    isMobile={this.state.isMobile}
                  />
                )}
              />
              <Route
                exact
                path={`/kontakt/`}
                render={state => (
                  <Contact
                    {...state}
                    fullName={this.state.fullName}
                    email={this.state.email}
                    message={this.state.message}
                    messageHeight={this.state.messageHeight}
                    handleSubmit={this.handleSubmit}
                    toggleFocused={this.toggleFocused}
                    isFocused={this.state.isFocused}
                    toggleBlurred={this.toggleBlurred}
                    isBlur={this.state.isBlur}
                    isValidating={this.state.isValidating}
                    handleInputChange={this.handleInputChange}
                    fullNameValidated={this.state.fullNameValidated}
                    emailValidated={this.state.emailValidated}
                    messageValidated={this.state.messageValidated}
                    submitBtnText={this.state.submitBtnText}
                    isStatusInfoVisible={this.state.isStatusInfoVisible}
                    statusInfo={this.state.statusInfo}
                    handleTextareaClear={this.handleTextareaClear}
                    isTextareaActive = {this.state.isTextareaActive}
                  />
                )}
              />
              <Route
                exact
                path={`/o-nas/`}
                render={state => (
                  <About
                    {...state}
                    about={this.state.about}
                    handleOverflow={this.handleOverflow}
                  />
                )}
              />
              <Route
                exact
                path={`/studio/`}
                render={state => (
                  <Studio
                    {...state}
                    isStudioLoading={this.state.isStudioLoading}
                    studio={this.state.studio}
                    handleScrollToElement={this.handleScrollToElement}
                    isMobile={this.state.isMobile}
                    getStudio={this.getStudio}
                  />
                )}
              />
            </Switch>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js